import React from 'react'
import { useSelector } from 'react-redux'
import Menu from 'antd/lib/menu'
import Badge from 'antd/lib/badge'
import { I18n } from 'aws-amplify'
import MenuIcons from './MenuIcons'
import { Link } from 'react-router-dom'
import AdminIcon from '../../../assets/images/manage.svg'
import ClientsIcon from '../../../assets/images/clients.png'
import TenantsIcon from '../../../assets/images/tenants.png'
import PropertiesIcon from '../../../assets/images/properties.svg'
import './SideMenu.css'

import {
    DASHBOARD,
    DOCUMENTS,
    NOTIFICATIONS,
    CALENDAR,
    TRAINING_PROGRAMS,
    PROCEDURES,
    REPORTS,
    RESOURCES,
    EVACUATION_ASSISTANCE,
    FLOOR_WARDEN,
    LIBRARY,
    PLAYLISTS,
    VIDEOS,
    QUIZZES,
    SUPPORT,
    MAP,
    FLOOR_PLANS,
    ADDITIONAL_RESOURCES,
    MANAGE,
    ACKNOWLEDGMENT,
    PROGRAM_REPORTS,
    ADMIN,
    CLIENTS,
    PROPERTIES,
    TENANTS,
    BUILDING,
} from '../../../constants/text'

const { SubMenu } = Menu

const SideMenu = () => {
    const modules = useSelector((state) => state.app.building.settings?.modules)
    const roles = useSelector((state) => state.app.user.roles)
    const requests = useSelector((state) => state.floorWarden.floorWardenRequests)
    const buildingpk = useSelector((state) => state.app.building.pk)
    const propertiespk = useSelector((state) => state.app.property.pk)
    const tenantpk = useSelector((state) => state.app.tenant.pk)

    const menuCreator = (modules, role) => {
        const getModule = (module) => {
            let mod = modules && modules.find((m) => m.key === module)
            return mod ? mod : { enabled: false }
        }

        return [
            {
                key: getModule('dashboard').key,
                title: DASHBOARD,
                link: '/',
                icon: 'dashboard',
                show: getModule('dashboard').enabled,
            },
            {
                key: 'training',
                title: TRAINING_PROGRAMS,
                link: '/trainingportal',
                icon: 'training',
                show: getModule('trainingPrograms').enabled,
            },
            {
                key: 'reports',
                title: REPORTS,
                link: '/reports',
                icon: 'report',
                show: getModule('reports').enabled,
                show: true,
            },

            {
                key: 'covid',
                title: 'Contact Tracing',
                link: '/covid',
                icon: 'covid',
                show: getModule('contactTracing').enabled,
            },
            {
                key: 'procedures',
                title: PROCEDURES,
                link: '/procedures',
                icon: 'procedures',
                show: getModule('procedures').enabled,
            },
            {
                key: 'evacAssistance',
                title: EVACUATION_ASSISTANCE,
                tooltip: EVACUATION_ASSISTANCE,
                link: '/assistance',
                icon: 'assistance',
                show: getModule('evacuationAssistance').enabled,
            },
            {
                key: 'floorWarden',
                title: FLOOR_WARDEN,
                link: '/floorwarden',
                icon: 'floorWarden',
                show: getModule('floorWarden').enabled || getModule('ert').enabled,
            },
            {
                key: 'dsal',
                title: 'FW Certification',
                link: '/dsal',
                icon: 'floorWarden',
                show: getModule('dsal').enabled,
            },
            {
                key: 'calendar',
                title: CALENDAR,
                link: '/calendar',
                icon: 'calendar',
                show: getModule('calendar').enabled,
            },
            {
                key: 'resources',
                title: RESOURCES,
                icon: 'resources',
                show: getModule('floorPlans').enabled || getModule('map').enabled || getModule('documents').enabled || getModule('additionalResources').enabled,
                subMenu: [
                    {
                        key: 'floorPlans',
                        title: FLOOR_PLANS,
                        icon: 'floorPlan',
                        link: '/floorplans',
                        show: getModule('floorPlans').enabled,
                    },
                    {
                        key: 'map',
                        title: MAP,
                        icon: 'map',
                        link: '/neighborhood',
                        show: getModule('map').enabled,
                    },
                    {
                        key: 'documents',
                        title: DOCUMENTS,
                        icon: 'documents',
                        link: '/documents',
                        show: getModule('documents').enabled,
                    },
                    {
                        key: 'additionalResources',
                        title: ADDITIONAL_RESOURCES,
                        tooltip: ADDITIONAL_RESOURCES,
                        icon: 'addResources',
                        link: '/resources',
                        show: getModule('additionalResources').enabled,
                    },
                ],
            },
            {
                key: 'administration',
                title: ADMIN,
                externalIcon: true,
                icon: AdminIcon,
                show: role.some(item => typeof item === 'string' && item.includes('_ADMIN')),
                subMenu: [
                    {
                        key: 'clients',
                        title: CLIENTS,
                        externalIcon: true,
                        icon: ClientsIcon,
                        link: '/admin/clients',
                        show: role.includes('CLIENT_ADMIN') || role.includes('SUPER_ADMIN'),
                    },
                    {
                        key: 'properties',
                        title: role.includes('BUILDING_ADMIN') ? BUILDING : PROPERTIES,
                        externalIcon: true,
                        icon: PropertiesIcon,
                        link: role.includes('BUILDING_ADMIN')
                            ? `/admin/buildings/${buildingpk}`
                            : role.includes('PROPERTY_ADMIN')
                                ? `/admin/properties/${propertiespk}`
                                : '/admin/properties',
                        show:
                            role.includes('PROPERTY_ADMIN') ||
                            role.includes('BUILDING_ADMIN') ||
                            role.includes('SUPER_ADMIN'),
                    },
                    {
                        key: 'tenants',
                        title: TENANTS,
                        externalIcon: true,
                        icon: TenantsIcon,
                        link: role.includes('TENANT_ADMIN')
                            ? `/admin/tenants/${tenantpk}`
                            : '/admin/tenants',
                        show:  role.includes('SUPER_ADMIN') || role.includes('TENANT_ADMIN')
                    },
                    {
                        key: 'evacAssistance',
                        title: EVACUATION_ASSISTANCE,
                        tooltip: EVACUATION_ASSISTANCE,
                        externalIcon: false,
                        link: '/reports/assistance',
                        icon: 'assistance',
                        show: !role.includes('SUPER_ADMIN') && getModule('evacuationAssistance').enabled
                    },
                    {
                        key: 'floorWarden',
                        title: FLOOR_WARDEN,
                        link: '/reports/floorwarden',
                        icon: 'floorWarden',
                        show: (!role.includes('SUPER_ADMIN') && !role.includes('TENANT_ADMIN')) && (getModule('floorWarden').enabled || getModule('ert').enabled),
                    },
                    {
                        key: 'notifications',
                        title: NOTIFICATIONS,
                        link: '/notifications',
                        icon: 'notifications',
                        show: getModule('notifications').enabled,
                    },
                    {
                        key: 'iamSafe',
                        title: "I'm Safe",
                        icon: 'report',
                        link: '/reports/iamsafe',
                        show: !role.includes('PROPERTY_ADMIN') && getModule('imsafe').enabled
                    },
                    {
                        key: 'dsal',
                        title: 'FW Certification',
                        link: '/reports/dsal',
                        icon: 'floorWarden',
                        show: !role.includes('TENANT_ADMIN') && getModule('dsal').enabled,
                    },
                    {
                        key: 'library',
                        title: LIBRARY,
                        externalIcon: false,
                        link: '/library',
                        icon: 'library',
                        show: role.includes('SUPER_ADMIN'),
                    },
                ],
            },
            {
                key: 'support',
                title: SUPPORT,
                link: '/support',
                icon: 'support',
                show: getModule('support').enabled,
            },
        ]
    }

    return (
        <Menu mode="inline" defaultOpenKeys={['resources']} style={{ borderRight: 0 }}>
            {menuCreator(modules, roles).map((item, index) => {
                return item.subMenu != null && item.show ? (
                    <SubMenu
                        key={item.key}
                        title={
                            <span>
                                <MenuIcons id={item.icon} externalIcon={item.externalIcon} />
                                {I18n.get(item.title)}
                            </span>
                        }
                    >
                        {item.subMenu.map((sitem) => {
                            return (
                                sitem.show && (
                                    <Menu.Item key={sitem.key}>
                                        <MenuIcons id={sitem.icon} externalIcon={sitem.externalIcon} />
                                        {sitem.key === 'floorWarden' ? (
                                            <Badge count={requests.length} offset={[15,0]}>
                                                <span className="menu-item-text">{I18n.get(sitem.title)}</span>
                                            </Badge>
                                        ) : (
                                            <span className="menu-item-text">{I18n.get(sitem.title)}</span>
                                        )}
                                        <Link to={sitem.link} />
                                    </Menu.Item>
                                )
                            )
                        })}
                    </SubMenu>
                ) : (
                    item.show && (
                        <Menu.Item key={index} style={{ padding: 0 }}>
                            <MenuIcons id={item.icon} externalIcon={item.externalIcon} />
                            <span className="menu-item-text">{I18n.get(item.title)}</span>
                            <Link to={item.link} />
                        </Menu.Item>
                    )
                )
            })}

        </Menu>
    )
}

export default SideMenu
